import { memo } from 'react';
import { WVULogoDark } from 'assets/logo';
import { SideIllustration } from 'assets/illustrations';
import { useNavigate } from 'react-router';
import { Container, LogoContainer } from './styled';

export const SidePanel = memo(() => {
  const navigate = useNavigate();
  return (
    <Container>
      <LogoContainer onClick={() => navigate('/')} role="button">
        <WVULogoDark />
      </LogoContainer>
      <SideIllustration />
    </Container>
  );
});
